import { FC, PropsWithChildren } from "react";
import { useMount } from "react-use";

import { redirector } from "@/utils";

export const PARTNER_SESSION_STORAGE_KEY = `ep_affiliate_partner`;

export const ProviderURLSearchParams: FC<PropsWithChildren> = ({
  children,
}) => {
  useMount(() => {
    const sp = new URLSearchParams(window.location.search);
    const partner = sp.get("partner");
    const next = sp.get("next");

    const inIframe = window.self !== window.top;

    if (partner && !inIframe) {
      sp.delete("partner");
      sessionStorage.setItem(PARTNER_SESSION_STORAGE_KEY, partner);

      window.history.pushState(
        null,
        "",
        window.location.pathname + (sp.size ? `?${sp.toString()}` : ""),
      );
    }

    if (next) {
      redirector.saveNext(next);

      sp.delete("next");
    }

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${sp.size ? "?" + sp.toString() : ""}`,
    );
  });

  return <>{children}</>;
};
